import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget';
import '../../paper-table/paper-table';
//import {v4 as uuidv4} from 'uuid';
import '../../style-modules/paper-table-style';
import '../../katapult-auth/katapult-auth';
('../katapult-elements/katapult-button.js');

class ApiWidget extends KatapultWidget {
  // Override widget title template
  static get widgetTitleTemplate() {
    return html`API Key Generation`;
  }

  // Override properties
  static get properties() {
    return {
      pageData: {
        type: Object,
        value: { title: 'API Key Generation', description: 'Generate an API key for your account.' }
      },
      lockApiKeyGen: {
        type: Boolean,
        value: false
      },
      emailAddress: {
        type: String,
        value: ''
      },
      userGroup: {
        type: String,
        value: ''
      },
      apiKey: {
        type: String,
        value: ''
      },
      apiAccessFlag: {
        type: Boolean,
        value: false
      },
      viewApiKey: {
        type: Boolean,
        value: false
      }
    };
  }

  // Override body template
  static get bodyTemplate() {
    return html`
      <style include="paper-table-style">
        paper-row {
          height: auto;
        }
      </style>
      <paper-table>
        <paper-row>User Group: [[userGroup]] </paper-row>
        <paper-row>Email: [[emailAddress]] </paper-row>
      </paper-table>
      <template is="dom-if" if="{{apiAccessFlag}}">
        <div slot="description">
          <p style="border-width:3px; border-style:solid; border-color:#FF0000; padding: 3px;">
            Anyone with this API Key will be able to authenticate with Katapult Pro using your user account and perform any actions
            available to the API as your user. Keep it secret. Keep it safe.
          </p>
          <label><b>API Key: </b></label>
          <div style="display:flex; justify-content:center;">
            <template is="dom-if" if="{{viewApiKey}}">
              <textarea disabled type="text" style="width:500px; height:auto" rows="4" cols="50" value="[[apiKey]]" readonly></textarea>
            </template>
            <template is="dom-if" if="{{!viewApiKey}}">
              <katapult-button color="var(--primary-color)" on-click="viewApiKeyButton" icon="visibility">View API Key</katapult-button>
            </template>
          </div>
        </div>
        <br />
        <template is="dom-if" if="{{viewApiKey}}">
          <div slot="buttons" style="text-align:right gap:10px">
            <template is="dom-if" if="{{!lockApiKeyGen}}">
              <katapult-button color="var(--primary-color)" on-click="generateApiKey" icon="cached">Generate Key</katapult-button>
              <katapult-button color="var(--primary-color)" on-click="copyApiKey" icon="content_copy">Copy Key</katapult-button>
            </template>
            <template is="dom-if" if="{{lockApiKeyGen}}">
              <katapult-button color="var(--primary-color)" on-click="regenerateKey" icon="cached">Regenerate Key</katapult-button>
              <katapult-button color="var(--primary-color)" on-click="copyApiKey" icon="content_copy">Copy Key</katapult-button>
            </template>
          </div>
        </template>
      </template>
      <template is="dom-if" if="{{!apiAccessFlag}}">
        <div slot="description">
          <p style="border-width:3px; border-style:solid; border-color:#FF0000; padding: 3px;">
            API Access is not enabled for your account. Please contact your company administrator to enable API Access. Once activated you
            will be able to generate an API Key.
          </p>
        </div>
        <br />
      </template>
    `;
  }

  ready() {
    super.ready();
    // Initialize properties to now
    this.emailAddress = this.user.email;
    this.userGroup = this.userGroup;
    this.widgetDataUpdate();
  }

  //********************************************************************************************************/
  // Functions for API Key Generation
  //********************************************************************************************************/
  // Generate API Key
  async generateApiKey() {
    this.lockApiKeyGen = false;
    let result = await firebase
      .functions()
      .httpsCallable('apiKeyManagement')({ action: 'generate' })
      .then((res) => res);
    this.apiKey = result.data;
  }

  // Regenerate API Key
  async regenerateApiKey() {
    // Generate a new API key
    this.lockApiKeyGen = true;
    let result = await firebase
      .functions()
      .httpsCallable('apiKeyManagement')({ action: 'generate' })
      .then((res) => res);
  }

  // Copy API Key
  async copyApiKey() {
    // Generate a new API key
    let copyText = this.apiKey;
    navigator.clipboard.writeText(copyText);
  }

  // View API Key
  async viewApiKeyButton() {
    setTimeout(() => {
      this.viewApiKey = false;
    }, 10000);
    this.viewApiKey = true;
  }

  // Widget Data Update
  async widgetDataUpdate() {
    let apiAccessPath = `/users/${this.userGroup}/${this.user.uid}/roles/photoheight/permissions/api_access`;
    this.apiAccessFlag = await FirebaseWorker.ref(apiAccessPath)
      .once('value')
      .then((s) => s.val());
    let result = await firebase
      .functions()
      .httpsCallable('apiKeyManagement')({ action: 'fetch' })
      .then((res) => res);
    if (result.data != null) {
      this.apiKey = result?.data?.key;
      setTimeout(() => {
        this.viewApiKey = false;
      }, 5000);
      this.viewApiKey = true;
    }
  }
}

window.customElements.define('katapult-api-widget', ApiWidget);
